module.exports = __webpack_public_path__ + "static/media/YLine.cda8ae77.png";